export const replaceValues = (str, values) => {
  values.forEach((value) => {
    let rep = new RegExp(value.label, "g");
    str = str.replace(rep, value.value);
  });

  return str;
};
